import React from 'react';

import './AdminMenuButton.css';

const AdminMenuButton = ({ children, onClickHandler }) => {
  return (
    <button className='admin-topbar-menu-button' onClick={onClickHandler}>
      {children}
    </button>
  );
};

export default AdminMenuButton;
